import { apiRequest } from './http';
import type {
  ExpandAllBody,
  ExpandAllResponse,
  GrantCreateBody,
  GrantBatchBody,
  GrantBatchResponse,
  GrantDeleteBody,
  GrantDeleteResponse,
  GrantMutationResponse,
  GrantPatchBody,
  RevokeAllBody,
  RevokeAllResponse,
} from './types';

export interface GameGrantOptions {
  email: string;
  stages: number[];
  project_ids: string[] | null;
}

export function getGameGrantOptions(email: string, signal: AbortSignal) {
  return apiRequest<GameGrantOptions>(`/users/${encodeURIComponent(email)}/game-grant-options`, { signal });
}

// §5.7 POST /api/grants — Admin 즉시 부여
export function createGrant(body: GrantCreateBody): Promise<GrantMutationResponse> {
  return apiRequest<GrantMutationResponse>('/grants', { method: 'POST', body });
}

export function applyGrantBatch(body: GrantBatchBody): Promise<GrantBatchResponse> {
  return apiRequest<GrantBatchResponse>('/grants/batch', { method: 'POST', body });
}

// §5.8 PATCH /api/grants — level 변경
export function updateGrant(body: GrantPatchBody): Promise<GrantMutationResponse> {
  return apiRequest<GrantMutationResponse>('/grants', { method: 'PATCH', body });
}

// §5.9 DELETE /api/grants — Admin 즉시 회수
export function deleteGrant(body: GrantDeleteBody): Promise<GrantDeleteResponse> {
  return apiRequest<GrantDeleteResponse>('/grants', { method: 'DELETE', body });
}

// §5.10 POST /api/grants/expand-all — 'all' → prefix 전환
export function expandAllGrant(body: ExpandAllBody): Promise<ExpandAllResponse> {
  return apiRequest<ExpandAllResponse>('/grants/expand-all', { method: 'POST', body });
}

// POST /api/grants/revoke-all — 한 사용자의 모든 권한 일괄 회수(퇴사 처리, Admin 전용)
export function revokeAllGrants(body: RevokeAllBody): Promise<RevokeAllResponse> {
  return apiRequest<RevokeAllResponse>('/grants/revoke-all', { method: 'POST', body });
}
